import { useEffect } from 'react';
import { useIsMobile } from './use-IsMobile';

export const useBeamer = ({ currUser }) => {
  const isMobile = useIsMobile();
  const callback = (count) => {
    const beamerIconCounter = document.querySelector('.beamer_icon');
    if (beamerIconCounter) {
      beamerIconCounter.innerText = count;
    }
  };
  useEffect(() => {
    if (!import.meta.env.VITE_BEAMER_ID) return;
    if (!currUser?.feature_options?.ats_enabled) return; // Disable for non-ATS customers
    if (window?.location?.host?.includes('ats-e2e.kulastg.com')) return;
    if (isMobile) return; // Disable for mobile devices
    const beamerDeatilsScript = document.createElement('script');
    beamerDeatilsScript.id = 'beamer-details';

    const accountName = window?.location?.hostname?.split('.')[0];
    var beamerConfig = {
      product_id: import.meta.env.VITE_BEAMER_ID,
      selector: 'showBeamer',
      user_firstname: currUser?.first_name,
      user_lastname: currUser?.last_name,
      user_email: currUser?.email,
      user_id: `${accountName}:${currUser?.id}`,
      user_custom_attributes: {
        role: currUser?.role,
        account_name: accountName,
      },
      callback: callback,
      multi_user: true,
    };

    beamerDeatilsScript.innerText = `var beamer_config = ${JSON.stringify(
      beamerConfig
    )}`;

    document.body.appendChild(beamerDeatilsScript);
    const beamerScript = document.createElement('script');
    beamerScript.id = 'beamer-script';
    beamerScript.type = 'text/javascript';
    beamerScript.src = 'https://app.getbeamer.com/js/beamer-embed.js';
    beamerScript.defer = 'defer';
    document.body.appendChild(beamerScript);
  }, [currUser, isMobile]);
};
